import { render, staticRenderFns } from "./DetailManualOrder.vue?vue&type=template&id=167f14eb"
import script from "./DetailManualOrder.vue?vue&type=script&lang=js"
export * from "./DetailManualOrder.vue?vue&type=script&lang=js"
import style0 from "./DetailManualOrder.vue?vue&type=style&index=0&id=167f14eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports